export default __webpack_public_path__ + "9079ecba0bc95ce76f6a620e688278cc.png";